import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const search = params => {
  return ApiService.post(`address/search`, params, {
    isLoading: false,
  });
};
